import React, { useMemo } from 'react';

import {
  Bar,
  BarColumn,
  BarGlow,
  Bars,
  BarTrack,
  Container,
  DayLabel,
  Header,
  Subtitle,
  Title,
} from './styles';

interface IFrequencyItem {
  day_of_week: number;
  label: string;
  value: number;
}

interface AttendanceChartProps {
  data: IFrequencyItem[];
  totalUsers: number;
}

const AttendanceChart: React.FC<AttendanceChartProps> = ({
  data,
  totalUsers,
}) => {
  const bars = useMemo(() => {
    // % do total de alunos cadastrados na academia que treinaram
    // especificamente naquele dia. Importante: o denominador precisa ser
    // uma contagem estável, independente dos treinos da própria semana --
    // já tentamos usar "alunos ativos na semana" (quem treinou pelo menos
    // 1x) e é um número circular, calculado a partir do mesmo dado que
    // esse gráfico mede: excluir um treino do histórico encolhe o
    // numerador E o denominador juntos, e o percentual nem se mexe.
    // `totalUsers` (alunos cadastrados na academia) não depende de quem
    // treinou, então o percentual reage de verdade a mudanças no histórico.
    return data.map(item => ({
      ...item,
      percent: totalUsers > 0 ? (item.value / totalUsers) * 100 : 0,
    }));
  }, [data, totalUsers]);

  return (
    <Container>
      <Header>
        <div>
          <Title>Tendências de Frequência</Title>
          <Subtitle>% de alunos cadastrados que treinaram, por dia</Subtitle>
        </div>
      </Header>
      <Bars>
        {bars.map(item => (
          <BarColumn key={item.day_of_week}>
            <BarTrack>
              <BarGlow height={item.percent} />
              <Bar height={item.percent} />
            </BarTrack>
            <DayLabel>{item.label}</DayLabel>
          </BarColumn>
        ))}
      </Bars>
    </Container>
  );
};

export { AttendanceChart };
